// @flow
/** @jsx jsx */

import { lighten } from 'polished';

import { Colors } from '@zapier/theme';
import { jsx } from '@emotion/core';

import RequiredOrOptionalLabel from 'app/beta-editor/components/formatic/RequiredOrOptionalLabel';

const Styles = {
  color: lighten(0.1, Colors.black),
  fontSize: '1.1em',
  fontWeight: 600,
  lineHeight: '14px',
};

type Props = {
  id: string,
  label: string,
  isRequired: boolean,
};

const FilterCategoryLabel = ({ id, label, isRequired }: Props) => (
  <label
    aria-required={isRequired}
    css={Styles}
    htmlFor={id}
    required={isRequired}
  >
    {label} {isRequired && <RequiredOrOptionalLabel isRequired={isRequired} />}
  </label>
);

export default FilterCategoryLabel;
